import { toast } from 'react-toastify'

export function sendErrorApiMessage(err, message) {
  if (err?.response?.data?.message) {
    console.log(`${message}: ${err.response.data.message}`)

    return toast.error(err.response.data.message)
  } else {
    console.log(`${message}: ${err}`)

    return toast.error(`${message}`)
  }
}
